import * as actionTypes from "../constants";
import * as apis from "../requests/apis";
import * as payloads from "../requests/payloads";
import { clientRequest, contentHeader } from "../requests";
import { showToast, TOAST_TYPE } from "utils/toast";

// Get Events
// NOTE: GET_EVENTS_API's URL is unchanged from the old backend (exact path
// match), so the `res.data.eventList` + pagination wrapper shape is assumed
// unchanged too — not verified against the new backend directly (it was down
// when this was written). Worth a real check once it's back up.
export const getEvents = (page, pageSize, reset = false) => async (dispatch) => {
  try {
    if(reset) dispatch({ type: actionTypes.RESET_EVENT });
    else dispatch({ type: actionTypes.FETCH_EVENTS });
    const res = await clientRequest(
      actionTypes.GET,
      `${apis.GET_EVENTS_API}?page=${page}&pageSize=${pageSize}`,
      null
    );
    const data = await payloads.getEventsPayload(res.data.eventList);
    const pagination = payloads.getPagination(res.data);

    dispatch({
      type: actionTypes.GET_EVENTS_SUCCESS,
      payload: {
        data,
        pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_EVENTS_FAIL,
      payload: err,
    });
  }
};

// If a new photo file was picked, upload it first and use the resulting
// url/key as photoUrl; otherwise keep whatever photoUrl the form already has.
const resolvePhotoUrl = async (form) => {
  if (form.photoFile) return payloads.uploadPhoto(form.photoFile);
  return form.photoUrl;
};

// Add Event
export const addEvent = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_EVENT });
    const photoUrl = await resolvePhotoUrl(form);
    const payload = payloads.eventPayload({ ...form, photoUrl });
    await clientRequest(actionTypes.POST, apis.CREATE_EVENT_API, payload, contentHeader);
    setTimeout(() => {
      dispatch({
        type: actionTypes.ADD_EVENT_SUCCESS,
      });
    }, 2000);
  } catch (err) {
    showToast(err?.response?.data || "Failed to add event.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.ADD_EVENT_FAIL,
      payload: err,
    });
  }
};

// Edit Event
export const editEvent = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_EVENT });
    const photoUrl = await resolvePhotoUrl(form);
    const payload = payloads.eventPayload({ ...form, photoUrl });
    await clientRequest(actionTypes.POST, apis.UPDATE_EVENT_API, payload, contentHeader);
    setTimeout(() => {
      dispatch({ type: actionTypes.ADD_EVENT_SUCCESS });
    }, 2000);
  } catch (err) {
    showToast(err?.response?.data || "Failed to update event.", TOAST_TYPE.error);
    dispatch({ type: actionTypes.EDIT_EVENT_FAIL, payload: err });
  }
};

// Delete Event
// NOTE: IdRequest's exact field casing wasn't confirmed (backend was down) —
// assumed camelCase `{ id }` to match every other DTO in this API.
export const deleteEvent = (form) => async (dispatch) => {
  try {
    await clientRequest(actionTypes.POST, apis.DELETE_EVENT_API, { id: form.id }, contentHeader);
    dispatch({
      type: actionTypes.DELETE_EVENT_SUCCESS,
      payload: form,
    });
  } catch (err) {
    showToast(err?.response?.data || "Failed to delete event.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.DELETE_EVENT_FAIL,
      payload: err,
    });
  }
};

// Reset Events Pagination
export const resetEventsPagination = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.RESET_EVENT_PAGINATION_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.RESET_EVENT_PAGINATION_FAIL,
    });
  }
};

// Get Advance Search
export const getAdvanceSearchEvent = (username) => async (dispatch) => {
  try{
    dispatch({ type: actionTypes.ADVANCE_SEARCH_REQUEST_EVENT });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${username}&searchType=event`);
    const data = await payloads.getEventsPayload(res.data);
    dispatch({
      type: actionTypes.GET_ADVANCE_SEARCH_EVENT_SUCCESS,
      payload: data,
    });
  }catch(err) {
    dispatch({ type: actionTypes.GET_ADVANCE_SEARCH_EVENT_FAIL, payload: err });
  }
}
